import React from 'react';

import { HeaderConfig } from '../types';

interface ScanHeaderProps {
  config: HeaderConfig;
  onClose: () => void;
  introActive?: boolean;
}

export const ScanHeader: React.FC<ScanHeaderProps> = ({ config, onClose, introActive }) => {
  return (
    <div className="ms-header">
      <div className="ms-logo">
        {introActive ? (
          <div className="ms-star-placeholder" />
        ) : (
          <img src={config.logoSrc} alt="Logo" />
        )}
        <span className="ms-logo-text">{config.logoText}</span>
      </div>
      <div className="ms-controls">
        {/* {config.locationText && (
          <span className="ms-header-location">
            {config.countryLogoSrc ? (
              <img src={config.countryLogoSrc} alt={config.locationText} className="ms-header-location-flag" />
            ) : (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            )}
            {config.locationText}
          </span>
        )} */}
        {/* <button className="ms-btn-help" type="button">?</button> */}
        <button className="ms-btn-close" type="button" onClick={onClose}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M9 3L3 9M3 3l6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>
      </div>
    </div>
  );
};
